import React from 'react'
import {Button, Flex, InjectedModalProps, Skeleton, Text} from '@pancakeswap/uikit'
import {useWeb3React} from '@web3-react/core'
import useTokenBalance, {FetchStatus} from '~/hooks/useTokenBalance'
import useAuth from '~/hooks/useAuth'
import {useTranslation} from '~/contexts/Localization'
import {getFullDisplayBalance} from '~/utils/formatBalance'
import tokens from '~/config/constants/tokens'
import CopyAddress from './CopyAddress'
import {useDisconnect} from "wagmi";

interface WalletInfoProps {
    hasLowBnbBalance: boolean
    onDismiss: InjectedModalProps['onDismiss']
}

const WalletInfo: React.FC<WalletInfoProps> = ({hasLowBnbBalance, onDismiss}) => {
    const {t} = useTranslation()
    const {address: account} = useAccount()
    const {balance: cakeBalance, fetchStatus: cakeFetchStatus} = useTokenBalance(tokens.cake.address)
    const {disconnect} = useDisconnect()

    const handleLogout = () => {
        onDismiss()
        disconnect()
    }

    return (
        <>
            <Text color="secondary" fontSize="12px" textTransform="uppercase" fontWeight="bold" mb="8px">
                {t('Your Address')}
            </Text>
            <CopyAddress account={account} mb="24px"/>
            <Flex alignItems="center" justifyContent="space-between" mb="24px">
                <Text color="textSubtle">{t('LUM Balance')}</Text>
                {cakeFetchStatus !== FetchStatus.SUCCESS ? (
                    <Skeleton height="22px" width="60px"/>
                ) : (
                    <Text>{getFullDisplayBalance(cakeBalance, 18, 3)}</Text>
                )}
            </Flex>
            <Button variant="secondary" width="100%" onClick={handleLogout}>
                {t('Disconnect Wallet')}
            </Button>
        </>
    )
}

export default WalletInfo
